import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as MODEL from '~/constants/ModelConstants';
import * as artifactActions from '~/artifact/actions';
import ArtifactViewReferencesListItem from '~/artifact/containers/ArtifactViewReferencesListItem';
type ArtifactViewMainContentReferencesProps = {
  actions: object;
  artifactState: object;
  artifact: object;
};
class ArtifactViewMainContentReferences extends React.Component<
  ArtifactViewMainContentReferencesProps,
  {}
> {
  componentDidMount() {
    const { artifactState } = this.props;
    const { artifact = {} } = artifactState;
    const { artifactLinks = [] } = artifact;
    const filters = {};
    artifactLinks.forEach(link => {
      if (!link.isDeleted && link.url && link.type) {
        filters[link.type] = true;
      }
    });
    this.props.actions.populateReferenceFilters(filters);
  }
  updateReferenceFilter = filter => {
    this.props.actions.toggleReferenceFilter(filter);
  };
  toggleDropdown = () => {
    this.props.actions.toggleReferenceDropdown();
  };
  render() {
    let self = this,
      store = this.props.artifactState,
      artifact = this.props.artifact,
      artifactLinks = artifact.artifactLinks || [],
      filterNameMap = MODEL.artifactViewFilterNameMap,
      listItems = [],
      isActive = store.isReferenceDropdownActive,
      referenceFilters = store.referenceFilters,
      activeFilterCount = 0,
      totalFilterCount = 0,
      filterItems = [];
    Object.keys(referenceFilters).forEach((filter, filterIndex) => {
      // increment the total filters count
      totalFilterCount++;
      if (referenceFilters[filter]) {
        // increment active filter count if active value is true
        activeFilterCount++;
      }
      // push all filters into the checkbox dropdown list
      filterItems.push(
        <li key={filter + '-' + filterIndex} className="list--group__item grid grid--full">
          <div className="grid__item">
            <label className="label--checkbox col-1-1 flex flex--justify-content--space-between flex--align-items--center">
              {filterNameMap[filter]}
              <input
                type="checkbox"
                name={filter}
                onChange={self.updateReferenceFilter.bind(self, filter)}
                checked={referenceFilters[filter]}
              />
              <span className="react--checkbox" />
            </label>
          </div>
        </li>
      );
    });
    // for each link, display if it's a full link and is not filtered out
    artifactLinks.forEach(function(link, linkIndex) {
      if (link.type && referenceFilters[link.type] && !link.isDeleted && link.url) {
        listItems.push(
          <div key={'list-item-row-' + linkIndex}>
            <ArtifactViewReferencesListItem link={link} linkIndex={linkIndex} isEditMode={false} />
          </div>
        );
      }
    });
    return (
      <section className="flex flex--flex-wrap--wrap pb phone--p0">
        <div className="col-1-2">
          <div className="pb position--relative">
            <div
              className="input--with-icon position--relative cursor--pointer"
              onClick={this.toggleDropdown}
            >
              <input
                type="text"
                className="cursor--pointer"
                placeholder={
                  (activeFilterCount === totalFilterCount
                    ? 'All'
                    : activeFilterCount + '/' + totalFilterCount) + ' filters selected'
                }
              />
              <i className="sci sci__caret--down bo-b--1 border-color--white-medium" />
            </div>
            <ul
              className={
                'list--group overflow-y--scroll border-color--dropdown right--0 col-1-1 b--1 position--absolute zIndex-9--overlay cursor--pointer' +
                (isActive ? ' is-showing-200 pb--' : ' is-hiding')
              }
            >
              {filterItems}
            </ul>
          </div>
        </div>
        <div className="col-1-1">{listItems}</div>
      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentReferences);
